import { render, staticRenderFns } from "./CoursePage.vue?vue&type=template&id=61156167&scoped=true"
import script from "./CoursePage.vue?vue&type=script&lang=js"
export * from "./CoursePage.vue?vue&type=script&lang=js"
import style0 from "./CoursePage.vue?vue&type=style&index=0&id=61156167&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61156167",
  null
  
)

export default component.exports